"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styles = require("./CardHeader.css");
var CardHeader = /** @class */ (function (_super) {
    __extends(CardHeader, _super);
    function CardHeader() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.customClass = _this.props.options.className || '';
        return _this;
    }
    CardHeader.prototype.render = function () {
        var backgroundStyles = {
            background: this.props.options.background ? this.props.options.background : '#008917',
        };
        return (React.createElement("div", { "data-test-id": this.props.testId, style: backgroundStyles, className: [styles.cardHeader, this.customClass].join(' ') }, this.props.data.title));
    };
    return CardHeader;
}(React.Component));
exports.default = CardHeader;
//# sourceMappingURL=CardHeader.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/CardHeader/CardHeader.js
// module id = 511
// module chunks = 8